export default $proposalModal => {
  const getForm = () => $proposalModal.form
  const getOpenModal = () => $proposalModal.openModal

  return { getForm, getOpenModal }
}
